import { C } from "./api";
import { GAME_LABELS } from "../components/lobby/GameFilters";

export const ROTATION = "ROTATION";
export const shortGame = (g) => GAME_LABELS[g] || C.GAME_RULES[g]?.label || g;
// "Mixed: Hold 'Em · Razz · Stud" for a rotation event, the game's own name otherwise
export const gameName = (ev, short = false) =>
  ev?.game === ROTATION ? `Mixed: ${(ev.rotation || []).map(shortGame).join(" · ")}` : short ? shortGame(ev?.game) : C.GAME_RULES[ev?.game]?.label || ev?.game;
